import { AuthConfig, Auth } from '@foxcorp/foxkit-auth-js/esm';
import Cookies from 'universal-cookie';
import { createApiTokenHandler } from './Api/RefreshTokenHandler';
import { getDefaultConfig } from './Store';
import { getAccessToken } from './UserCookie';

//Helpers related to AuthSDK which is generally for MVPD

const cookies = new Cookies();

let auth = {};

const apisIncludedInRefreshTokenHandling = [
  'getAdobeRegCode',
  'checkAdobeAuthN',
  'getEntitlements',
  'getUserMetadata',
  'logoutOfMVPD',
];

export const authSDK = () => auth;

export const createAuthInstance = (accessToken) => {
  const { appVersion, appEnv, accountApiKey, foxApi, deviceIdCookieName } = getDefaultConfig();

  const config = {
    apiKey: accountApiKey, // your api key
    baseUrl: foxApi,
    environment: appEnv, // development, qa, staging, production
    accessToken: accessToken || getAccessToken(), // optional user accessToken, otherwise undefined
    dcgUdid: cookies.get(deviceIdCookieName), //optional deviceId
    appName: 'fox-nation-commerce', // required - your app name, e.g. 'Fox Now',
    appVersion, // required - your app version
    httpClientTimeout: 10000, // the number of milliseconds before an http request times out
  };

  for (const key of Object.getOwnPropertyNames(Auth.prototype)) {
    if (apisIncludedInRefreshTokenHandling.includes(key)) {
      const originalMethod = Auth.prototype[key];
      Auth.prototype[key] = function () {
        return createApiTokenHandler(() => originalMethod.apply(this, arguments));
      };
    }
  }

  const authConfig = new AuthConfig(config);
  auth = new Auth(authConfig);
};
